import {
    Dispatch,
    SetStateAction,
    createContext,
    useContext,
    useEffect,
    useState
} from "react";
import { SelectedFilterInterface } from "storyblok/components";
import { useRouter } from "next/router";

import { paramsToState, stateToParams } from "helpers/util/params";

interface FilterOptionsContextModel {
    filterOptions: SelectedFilterInterface;
    setFilterOptions: Dispatch<SetStateAction<SelectedFilterInterface>>;
}

export const FilterOptionsContext = createContext(
    {} as FilterOptionsContextModel
);

export function useFilterOptions() {
    return useContext(FilterOptionsContext);
}

interface FilterOptionsProviderProps {
    children?: React.ReactNode;
}

export function FilterOptionsProvider({
    children
}: FilterOptionsProviderProps) {
    const router = useRouter();
    const [filterOptions, setFilterOptions] = useState<SelectedFilterInterface>(
        {
            certificationsFilter: [],
            departmentsFilter: [],
            distanceFilter: [],
            employmentTypeFilter: [],
            maximumHoursFilter: 40,
            minimumHoursFilter: 0,
            regionsFilter: [],
            zzpHoursFilter: []
        }
    );
    const [initialLoad, setInitialLoad] = useState(true);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);

        if (initialLoad) {
            setInitialLoad(false);

            paramsToState(params, setFilterOptions);
            return;
        }

        const oldUrl = router.asPath;

        const newUrl = stateToParams(filterOptions, params);

        if (newUrl !== oldUrl) {
            router.push(newUrl, undefined, { scroll: false });
        }
    }, [
        filterOptions,
        filterOptions.departmentsFilter,
        filterOptions.departmentsFilter.length,
        initialLoad,
        router
    ]);

    return (
        <FilterOptionsContext.Provider
            value={{ filterOptions, setFilterOptions }}
        >
            {children}
        </FilterOptionsContext.Provider>
    );
}
